module.exports = __webpack_public_path__ + "static/media/neutral.f3f900fb.png";